import type { TFunction } from 'i18next';

/**
 * Marker of the offer lines in the customer e-mail text. The server puts the
 * lines there (product, quantity, sale price, value, net total) from the saved
 * order — `orderCustomerStatusEmailService.OFFER_LINES_MARKER`. The browser
 * never assembles prices: Operacje (no sale prices) get a preview without
 * them, the e-mail that goes out always has them (owner decision 2026-10-05).
 */
export const OFFER_LINES_MARKER = '[pozycje oferty]';

/**
 * Default text of „Wyślij do klienta” on the Oferta step. The customer e-mail
 * layout takes the first line as the title („Oferta …”), then a neutral lead,
 * the offer lines (server-side, at the marker) and a closing; the sender may
 * edit everything around the marker.
 */
export function buildOfferEmailText(input: { orderNumber: string }, t: TFunction): { subject: string; message: string } {
  const { orderNumber } = input;
  const message = [
    t('orders:process.offer.emailTitle', { orderNumber }),
    t('orders:process.offer.emailLead', { orderNumber }),
    OFFER_LINES_MARKER,
    t('orders:process.offer.emailClosing'),
  ].join('\n\n');
  return { subject: t('orders:process.offer.emailSubject', { orderNumber }), message };
}
